var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Preview file", size: "lg" },
      on: { hide: _vm.closeHandler, show: _vm.onShowHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "ButtonOutline",
                {
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.modal.hide()
                    },
                  },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-spinner")
        : _vm.items[_vm.currentItemId]
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "10" } },
                [
                  _vm.items.length > 1
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-link",
                            {
                              staticClass: "c-preview-file__nav--link",
                              attrs: { disabled: _vm.currentItemId === 0 },
                              on: {
                                click: function ($event) {
                                  _vm.currentItemId--
                                },
                              },
                            },
                            [_vm._v("\n          Prev\n        ")]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("|")]),
                          _vm._v(" "),
                          _c(
                            "b-link",
                            {
                              staticClass: "c-preview-file__nav--link",
                              attrs: {
                                disabled:
                                  _vm.currentItemId === _vm.items.length - 1,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.currentItemId++
                                },
                              },
                            },
                            [_vm._v("\n          Next\n        ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      "table-class": "c-preview-file__table",
                      stacked: "",
                      bordered: "",
                      items: [_vm.items[_vm.currentItemId]],
                      fields: _vm.fields,
                    },
                  }),
                  _vm._v(" "),
                  _c("b-link", [_c("i", { staticClass: "cil-crop" })]),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "2" } }, [
                _c("div", { staticClass: "c-preview-file__preview" }, [
                  _c("img", {
                    staticClass: "c-preview-file__preview--image",
                    attrs: {
                      src: _vm.items[_vm.currentItemId].thumbnail,
                      alt: _vm.items[_vm.currentItemId].name,
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.items[_vm.currentItemId].alt_url
                  ? _c("div", { staticClass: "c-preview-file__preview mt-2" }, [
                      _c("img", {
                        staticClass: "c-preview-file__preview--image",
                        attrs: { src: _vm.items[_vm.currentItemId].alt_url },
                      }),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _c("b-alert", { attrs: { variant: "danger" } }, [
            _vm._v("\n    No item.\n  "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }